import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Header from 'components/Header';
import Loading from 'components/Loading';
import styles from './index.less';
import { btnBackgroundColor } from '@/utils/theme';
import { getValue, getShowTopBar } from 'utils/getValue';
import { languageMap } from '@/config/language';
import { getLang } from '../railSetMeal/common/util';
import { getUrlParam } from '@/utils';
import classNames from 'classnames';
import bg from '@/assets/images/bg@2x.png';
import bgRed from '@/assets/images/bg_red.png';
import { getLanguage } from '@/utils/getValue';
const UseSucModal = React.lazy(() => import('components/UseSucModal'));

const balanceTypeKey = {
  0: 'Classic',
  1: 'Prestige',
  2: 'Unlimited2',
};

// 20241106 苏浩有需求，特色展示banner背景图
const bannerBg = {
  18869: bgRed, // 蓝海银行-高铁休息室
  22524: bgRed, // 蓝海银行高铁转增专用
  18868: bgRed, // 蓝海银行-机场休息室
  18870: bgRed, // 蓝海银行机场-转赠专用
  36165: bgRed, // 蓝海银行-机场休息室-20241225新增
  36163: bgRed, // 蓝海银行-高铁休息室-20241225新增
};

@connect(({ home, loading }) => ({
  data: home.data,
  loading: loading.effects['home/queryQrcodeIndex'],
}))
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lg: 'zh-cn', // 因为需要切换中英文，所以不能用getLanguage和缓存的
      record: {},
      showUseModal: false,
      bannerBg: bg,
    };
  }

  componentDidMount() {
    console.log('333');
    const { dispatch } = this.props;
    let { channel, language, goUse } = (this.props.location && this.props.location.query) || {};
    const dragoncode = getValue('dragoncode');
    const qrcode = getValue('qrcode');
    const stateLg = getLanguage() || this.state.lg;
    dispatch({
      type: 'home/queryQrcodeIndex',
      payload: {
        dragoncode,
        qrcode,
      },
      callback: (res) => {
        if (Number(goUse) === 1) {
          return this.toUse(channel, 'replace');
        }
        const showEnText = ['32087'];
        const agentId = res.card.agentId;
        if (showEnText.includes(agentId)) {
          localStorage.setItem('language', 'en');
          language = 'en';
        }
        const lg = language || stateLg;
        let setStateData = {
          showUseModal: true,
          lg,
        };
        // 20241106 苏浩有需求，特色展示banner背景图
        if (bannerBg[agentId]) {
          setStateData.bannerBg = bannerBg[agentId];
        }
        this.setState(setStateData);
        channel && localStorage.setItem('channel', channel);
        localStorage.setItem('language', lg);
      },
    });
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
  }

  onchange = (which) => {
    this.setState({ lg: which });
    localStorage.setItem('language', which);
    window.location.reload();
  };

  toUse(channel, type = 'push') {
    const dragoncode = localStorage.getItem('dragoncode');
    const path = channel === 'unionpay' ? '/use/unionPay' : 'use';
    router[type]({
      pathname: path,
      query: {
        dragoncode,
        channel,
        language: this.state.lg,
      },
    });
  }

  toSearch() {
    const dragoncode = localStorage.getItem('dragoncode');
    const query = {
      dragoncode,
      language: this.state.lg,
    };
    const hideType = getUrlParam('hideType');
    if (hideType) query.hideType = hideType;
    router.push({
      pathname: '/search',
      query,
    });
  }

  toRecord(isLogin) {
    const dragoncode = localStorage.getItem('dragoncode');
    if (isLogin) {
      router.push({
        pathname: '/record',
        query: {
          dragoncode,
          language: this.state.lg,
        },
      });
    } else {
      router.push({
        pathname: '/step',
        query: {
          dragoncode,
          language: this.state.lg,
        },
      });
    }
  }

  // 跳转高铁餐食详情页
  toRailSetMeal(data) {
    const { dragoncode, agentId } = data.card || {};
    router.push({
      pathname: '/railSetMeal',
      query: {
        dragoncode,
        agentId,
        language: this.state.lg,
      },
    });
  }

  render() {
    const { channel, language } = (this.props.location && this.props.location.query) || {};
    let { data, loading } = this.props;
    const showTopBar = getShowTopBar();
    const {
      name,
      tips,
      agentName,
      partnerPoint,
      enName,
      enTips,
      agentEnName,
      enPartnerPoint,
      totalPoint,
      showUseBtn,
      showRailBtn, // 控制是否展示高铁餐食入口
      showAvailableNetworkBtn, // 控制可用网络按钮显示
      gq,
      pointLable,
      showBalanceType,
      logo,
      invalidEnTips,
      invalidTips,
    } = data || {};

    const { dragoncode, balanceType, expiryDateShow } = data.card || {};
    const { bannerBg, showUseModal } = this.state;
    const lg = language || this.state.lg || getLang();
    const isShow = language === undefined || language === 'undefined' || language === '';
    const isZhcn = lg === 'zh-cn';
    const lgText = languageMap[lg];

    if (dragoncode) localStorage.setItem('dragoncode', dragoncode);

    // 卡类型字 0点卡Classic  1年卡Prestige  2无限卡Unlimited2
    const isClassic = balanceType === 0; // 是否是点卡
    // 查看休息室网络字眼，如果channel=bankcomm 特殊显示
    let balanceTypeText = lgText[balanceTypeKey[balanceType]];
    const isBankcomm = channel === 'bankcomm';
    let networkText = lgText[isBankcomm ? 'NetworkBankcomm' : 'Network'];
    const issuerText = isZhcn ? agentName : agentEnName; // 发卡机构
    const tipsText = isZhcn ? tips : enTips;
    const partnerPointText = isZhcn ? partnerPoint : enPartnerPoint;
    let userName = (isZhcn ? name : enName) || '';
    let title = lgText.AccessLounge;
    let invalidTipsText = isZhcn ? invalidTips : invalidEnTips;
    if (isBankcomm) {
      userName = userName.replace(/^./, '*');
    }
    // 如果是北京私行隐藏点卡，年卡等
    if (channel === 'bjsh') {
      networkText = '查看可用网点';
      title = '服务凭证';
    }
    // 是否展示卡类型
    const hideBalanceTypeText = ['bankcomm', 'bjsh'];
    if (hideBalanceTypeText.includes(channel)) {
      balanceTypeText = '';
    }
    // 是否展示有校日期
    const hideExpiryDateList = ['spdb', 'bjsh', 'bankcomm'];
    const showExpirDateBox = !hideExpiryDateList.includes(channel); // 是否展示有校日期
    const expiryDateText = expiryDateShow;
    // 是否展示卡点数(头部卡样式右边)
    const hideCardPoint = ['haier', 'bankcomm'];
    if (!isClassic) hideCardPoint.push('bosc');
    const showCarPoint = !hideCardPoint.includes(channel);
    // 可用点数文字
    let canUseNumText = lgText.AvailableVisits;
    // 如果是中文并且接口有返回 pointLable 字段
    if (isZhcn && pointLable) canUseNumText = pointLable;
    if (channel === 'pingan') canUseNumText = lgText.AvailableVisits2;
    if (channel === 'bjsh') canUseNumText = lgText.AvailableVisits3;
    if (showBalanceType === false) balanceTypeText = '';
    // 卡信息  hideChannels存在其中一个channel就隐藏    showIfs存在一种条件就显示
    const infoArr = [
      {
        // 持卡人
        type: 'Cardholder',
        left: lgText.Cardholder,
        right: userName,
      },
      {
        // 发卡机构
        type: 'Issuer',
        left: lgText.Issuer,
        right: issuerText,
        hideChannels: ['haier'],
      },
      {
        // 可用点数  20230703 以前有判断接口的channel是否等于default但后面发现这个值不会变，所以暂时淘汰了这个
        type: 'canUseNumText',
        left: canUseNumText,
        right: totalPoint,
        hideChannels: hideCardPoint,
      },
      {
        // 本人可用
        type: 'CardholderVisit',
        left: lgText.CardholderVisit,
        right: lgText.Unlimited,
        hideChannels: ['bjsh', 'haier', 'bankcomm'],
        showIfs: [!isClassic], // 不是点卡就展示
      },
      {
        // 携伴点数
        type: 'GuestVisits',
        left: lgText.GuestVisits,
        right: partnerPointText,
        hideChannels: ['bjsh', 'haier', 'bankcomm'],
        showIfs: [!isClassic], // 不是点卡就展示
      },
      {
        // 有效日期
        type: 'Expirydate',
        left: lgText.Expirydate,
        right: expiryDateText,
        hideChannels: hideExpiryDateList,
      },
    ];

    return (
      <Fragment>
        <Header title={title} />
        <Loading loading={loading}>
          <div className={classNames([showTopBar ? 'mainContent' : 'notHeader', styles.homeBox])}>
            <div className={`${styles.cardBox} ${isShow ? styles.h500 : styles.h388}`}>
              <img
                className={`${styles.bg} ${isShow ? styles.h418 : styles.h306}`}
                src={bannerBg}
                alt=""
              />

              {isShow && (
                <div className={styles.tab}>
                  <div
                    style={{ cssFloat: 'left', paddingRight: '5%', textAlign: 'right' }}
                    onClick={() => this.onchange('zh-cn')}
                  >
                    <span className={this.state.lg === 'zh-cn' ? styles.selected : ''}>中文</span>
                  </div>
                  <div
                    style={{ cssFloat: 'right', paddingLeft: '5%' }}
                    onClick={() => this.onchange('en')}
                  >
                    <span className={this.state.lg === 'en' ? styles.selected : ''}>English</span>
                  </div>
                </div>
              )}

              <div className={`${styles.cardWrap} ${isShow ? styles.top140 : styles.top28}`}>
                <img className={styles.card} src={require('images/card-bg@2x.png')} alt="" />
                <img className={styles.logo} src={logo || require('images/logo@2x.png')} alt="" />
                <div
                  className={styles.cardNo}
                  dangerouslySetInnerHTML={{ __html: data.dpid }}
                ></div>

                <Fragment>
                  {balanceTypeText && <div className={styles.classic}>{balanceTypeText}</div>}
                  {showExpirDateBox && (
                    <Fragment>
                      <div className={styles.expiryDateClass}>{lgText.Expirydate}</div>
                      <div className={styles.expiryDate}>{expiryDateText}</div>
                    </Fragment>
                  )}
                  {/* 海尔隐藏字段 */}
                  {showCarPoint && (
                    <Fragment>
                      <div className={styles.AvailableVisitsClass}>{canUseNumText}</div>
                      <div className={styles.remainPoint}>
                        {isClassic
                          ? `${totalPoint}${channel === 'pingan' ? '人次' : ''}`
                          : lgText.Unlimited}
                      </div>
                    </Fragment>
                  )}
                </Fragment>
              </div>
            </div>

            <div className={styles.btns}>
              {showUseBtn && (
                <span onClick={() => this.toRecord(data.isLogin)}>{lgText.Record}</span>
              )}
              {/* 根据业务需要 仅针对中文支持高铁餐食 */}
              {showRailBtn && lg === 'zh-cn' && (
                <span onClick={() => this.toRailSetMeal(data)}>{lgText.RailSetMeal}</span>
              )}
              {showAvailableNetworkBtn && channel !== 'bcm' && (
                <span
                  onClick={this.toSearch.bind(this)}
                  className={showUseBtn ? '' : styles.onlyOne}
                >
                  {showUseBtn ? null : <img src={require('images/ico_present@2x.png')} alt="" />}
                  {networkText}
                </span>
              )}
              {channel === 'bcm' && (
                <span
                  onClick={this.toSearch.bind(this)}
                  className={showUseBtn ? '' : styles.onlyOne}
                >
                  {showUseBtn ? null : <img src={require('images/ico_present@2x.png')} alt="" />}
                  贵宾室服务范围
                </span>
              )}
            </div>

            <div className={styles.contentWrap}>
              <div className={styles.contentInner}>
                {infoArr.map((el) => {
                  const { left, right, hideChannels, showIfs, type } = el;
                  // 需要隐藏的channel
                  if (hideChannels) {
                    const isHide = hideChannels.includes(channel);
                    if (isHide) return null;
                  }
                  // 如果有需要展示的条件但不符合就不展示，比如balanceType=0的情况
                  if (showIfs && !showIfs.includes(true)) return null;
                  return (
                    <div className={styles.block} key={type}>
                      <span className={styles.left}>{left || lgText[type]}</span>
                      <span className={styles.right}>{right}</span>
                    </div>
                  );
                })}

                <div className={styles.line} />
                <div className={styles.notesWrap}>
                  <div className={styles.title}>{lgText.Notes}</div>
                  <div
                    className={styles.notes}
                    dangerouslySetInnerHTML={{ __html: tipsText }}
                  ></div>
                </div>
              </div>
            </div>

            <div className={styles.footer}>
              {gq === '0' ? (
                <div
                  className={styles.btn}
                  style={{ background: btnBackgroundColor[channel] }}
                  onClick={() => this.toUse(channel)}
                >
                  {lgText.Usebtn}
                </div>
              ) : (
                <div className={styles.btn} style={{ background: '#cfcfcf' }}>
                  {invalidTipsText}
                </div>
              )}
            </div>
          </div>
        </Loading>
        {showUseModal && (
          <React.Suspense fallback={'加载中...'}>
            <UseSucModal />
          </React.Suspense>
        )}
      </Fragment>
    );
  }
}

export default Home;
